import { autoserialize, autoserializeAs } from 'cerialize';
import { RandomScreeningDriverSelection } from './random-screening-driver-selection';
import { Screening } from './screening';
import { TransitProgramDriverStatus } from './transit-program-driver-status';
import { VehicleStatus } from './vehicle-status';

export class DriverAccountStatus {
  @autoserialize
  driverId: number;

  @autoserialize
  status: string;

  @autoserialize
  missingAddress: boolean;

  @autoserialize
  missingTransitPrograms: boolean;

  @autoserialize
  pendingCollectionSiteSelection: boolean;

  @autoserialize
  screeningPendingCollectionSite: Screening;

  @autoserialize
  missingVehicles: boolean;

  @autoserialize
  missingProfilePicture: boolean;

  @autoserialize
  missingPayoutAccount: boolean;

  @autoserialize
  missingSsn: boolean;

  @autoserialize
  missingMiddleName: boolean;

  @autoserialize
  missingVehicleOwnership: boolean;

  @autoserialize
  missingDriversLicenseSexAndCity: string;

  @autoserialize
  vehicleOwnershipRequired: boolean;

  @autoserialize
  taxIdType: string;

  @autoserialize
  taxDocumentStatus: string;

  @autoserializeAs(TransitProgramDriverStatus)
  transitProgramDriverStatuses: Array<TransitProgramDriverStatus>;

  @autoserializeAs(VehicleStatus)
  vehicleStatuses: Array<VehicleStatus>;

  @autoserializeAs(RandomScreeningDriverSelection)
  randomScreeningDriverSelection: RandomScreeningDriverSelection;
}
